import React, { useContext, useState } from "react";
import styled from "styled-components";
import { AppContext } from "../../contexts/AppContext";
import { useOptionsClientId } from "../../hooks/useOptionsClientId";
import GlobalAppDataPanel from "./GlobalAppDataPanel";
import UserAppDataPanel from "./UserAppDataPanel";
import QueryAppDataPanel from "./QueryAppDataPanel";
import { Muted, Small, Toolbar, Wrapper } from "./AppDataStyles";

// App Data: global rows, one user's rows, and a cross-user query.

const Tabs = styled(Toolbar)`
  border-bottom: 1px solid var(--main-border-color);
  padding-bottom: 10px;
`;

const TITLES = {
  global: "Global data",
  user: "By user",
  query: "Across users",
};

export const AppDataManager = () => {
  const { selectedClient } = useContext(AppContext);

  // Client admins are scoped by the session; platform admins pass the selected client.
  const clientId = useOptionsClientId();
  const usersClientId = selectedClient?.id ?? null;

  const [tab, setTab] = useState("global");

  return (
    <Wrapper>
      <div>
        <div style={{ fontSize: "20px", fontWeight: 700, color: "var(--main-font-color)" }}>App Data</div>
        <Muted>
          Server-to-client state store for
          {selectedClient?.name ? ` ${selectedClient.name}` : " this client"} — global rows are
          shared by every user; user rows are per person.
        </Muted>
      </div>

      <Tabs>
        {Object.entries(TITLES).map(([key, label]) => (
          <Small key={key} type="button" $active={tab === key} onClick={() => setTab(key)}>
            {label}
          </Small>
        ))}
      </Tabs>

      {tab === "global" ? <GlobalAppDataPanel clientId={clientId} /> : null}
      {tab === "user" ? <UserAppDataPanel clientId={clientId} usersClientId={usersClientId} /> : null}
      {tab === "query" ? <QueryAppDataPanel clientId={clientId} /> : null}
    </Wrapper>
  );
};

export default AppDataManager;
